import {Component, Output, EventEmitter, ElementRef, Input} from '@angular/core';

import {DefaultPackage} from '../services/capd.model';
import { PackageService } from '../services/package.service';

declare var $: any;

@Component({
  selector: 'package-publish',
  templateUrl: './package-publish.component.html',
  // inputs: ['pack']
})

/**
 * Modal that confirms publishing of package.
 */
export class PackagePublishComponent {
  @Output() listChange: EventEmitter<any> = new EventEmitter();
  @Input() pack: DefaultPackage;

  constructor(
    private _service: PackageService,
    private _el: ElementRef) { }

  /**
   * When confirmed, goes through with publishing the package and dismisses the modal.
   */
  onPublish() {
    this._service.publishPackage(this.pack).then(() => {
      this.listChange.emit(null);
      $(this._el.nativeElement).find('#modal-add-package').hide();
    });
  }
}
